import { render } from "./BotaoDadosAbertos.vue?vue&type=template&id=611eb7e0"
import script from "./BotaoDadosAbertos.vue?vue&type=script&lang=js"
export * from "./BotaoDadosAbertos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__